export const debounce = (callback: (arg0: any) => void, timeout: number | undefined) => {
  let id: NodeJS.Timeout
  return (...args: any[]) => {
    clearTimeout(id)
    return (id = setTimeout(() => { callback(args); }, timeout))
  }
}
